import { EmptyState } from '@e2n/ui/v2';
import { faArrowProgress } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

type EmptyCardProps = {
  titleKey: string;
  subtitleKey: string;
};

export function EmptyCard({ titleKey, subtitleKey }: EmptyCardProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full bg-backgrounds-primary rounded-xl p-8 flex justify-center items-center">
      <EmptyState
        icon={<FontAwesomeIcon icon={faArrowProgress} />}
        title={t(titleKey)}
        description={t(subtitleKey)}
      />
    </div>
  );
}
